<template>
  <div class="card-row">
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Picture-Article.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>
          Emergency Situations and the Role of Short-Term Loans in South Africa
        </h2>
        <p>
          Emergency situations often come without warning, leaving individuals
          and families in South Africa facing...
        </p>
        <router-link :to="{ name: 'BlogPage' }">Read more</router-link>
      </div>
    </div>

    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner2.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>Understanding Short Term Loans: The Basics and Benefits</h2>
        <p>
          In South Africa, a startling statistic revealed that in 2021, 76% of
          South Africans regularly ran out of money....
        </p>
        <router-link :to="{ name: 'HelpfulInfoArticle' }"
          >Read more</router-link
        >
      </div>
    </div>

    <!-- The Future of Short-Term Lending in South Af... -->
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner10.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>The Future of Short-Term Lending in South Africa's Economy</h2>
        <p>
          The short-term lending industry in South Africa is poised for
          significant change as technological...
        </p>
        <router-link :to="{ name: 'HelpfulInfoArticle3' }"
          >Read more</router-link
        >
      </div>
    </div>

    <!-- How to Avoid Over-indebtedness -->
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner12.png"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>How to Avoid Over-indebtedness</h2>
        <p>
          Running into money problems has long since become the least bit
          uncommon. In fact, most people are...
        </p>
        <router-link :to="{ name: 'HelpfulInfoArticle4' }"
          >Read more</router-link
        >
      </div>
    </div>

    <!-- Understanding South Africa’s Current Economic Climate -->
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner11.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>Understanding South Africa’s Current Economic Climate</h2>
        <p>
          South Africa, a nation rich in natural resources and cultural
          diversity, is currently navigating a complex...
        </p>
        <router-link :to="{ name: 'HelpfulInfoArticle5' }"
          >Read more</router-link
        >
      </div>
    </div>

    <!--  The Role of Short-Term Loans in... -->
    <div class="card" @click="navigateToDetailsPage">
      <img
        src="@/assets/img/public/pages/blog/Lime-24-Blog-Banner13.jpg"
        alt="Image"
        class="card-image"
      />
      <div class="card-content">
        <h2>The Role of Short-Term Loans in Supporting Small Businesses</h2>
        <p>
          To survive financially in today's financial climate, many salary
          earners start small businesses to supplement...
        </p>
        <router-link :to="{ name: 'HelpfulInfoArticle6' }"
          >Read more</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimeAllArticle",
  data() {
    return {
      articles: [
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "How to Determine If a Short-Term Loan Is Right for You",
          text: `Navigating the financial landscape can be daunting, especially when unexpected expenses arise. Century Financial Services,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "Understanding Short Term Loans: The Basics and Benefits",
          text: `In South Africa, a startling statistic revealed that in 2021, 76% of South Africans regularly ran,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne:
            "Tips for Responsible Borrowing: Making the Most of Your Short-Term Loan.",
          text: `Navigating the financial landscape can be daunting, especially when unexpected expenses arise. Century Financial Services,`,
        },
        {
          img: "@/assets/img/public/pages/blog/Lime-24-Blog-Banner1.jpg",
          headingOne: "How to Determine If a Short-Term Loan Is Right for You",
          text: `In South Africa, short-term loans provide immediate financial relief, but they come with significant responsibilities.`,
        },
      ],
    };
  },
  methods: {
    navigateToDetailsPage() {
      // You can navigate programmatically using router.push
      this.$router.push();
    },
  },
};
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* Adjust as needed */
}

.card {
  height: 440px;
  overflow: hidden;
  position: relative;
  transition: transform 0.2s ease;
  margin-bottom: 2em;
  border-radius: 0;
  width: calc(50% - 10px);
  margin-bottom: 20px;
  font-size: 15px;
}

@media only screen and (max-width: 768px) {
  .card-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95vw;
  }

  .card {
    width: 80% !important;
    height: 520px !important;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
}

.card:hover {
  transform: scale(1.05);
}

.card-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
  width: 100%;
}

.card-content {
  padding: 20px;
}
</style>
